import { SVGProps } from 'react';

const CheckboxChecked = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.99997 6.49998C1.99997 4.01469 4.01469 1.99998 6.49997 1.99998H15.5C17.9852 1.99998 20 4.01469 20 6.49998V15.5C20 17.9853 17.9852 20 15.5 20H6.49997C4.01469 20 1.99997 17.9853 1.99997 15.5V6.49998ZM15.1539 9.64552L10.8789 13.9205C10.7259 14.0735 10.5279 14.1455 10.3209 14.1455C10.1229 14.1455 9.92486 14.0735 9.77186 13.9205L7.62986 11.7875C7.32386 11.4725 7.32386 10.9775 7.62986 10.6715C7.93586 10.3655 8.43986 10.3655 8.74586 10.6715L10.3209 12.2465L14.0379 8.52952C14.3439 8.22352 14.8479 8.22352 15.1539 8.52952C15.4599 8.84452 15.4599 9.33952 15.1539 9.64552Z"
      fill={fill}
    />
  </svg>
);

export default CheckboxChecked;
